<template>
	<div>
		<ja-button
			ref="triple-dot"
			name="tiple-dot"
			:aria-label="$t('moreMenu')"
			class="small transparent more-menu-btn"
			@click.native="toggleTooltip()"
		>
			<svgicon class="more-menu" :original="true" name="more"></svgicon>
		</ja-button>
		<ja-tooltip
			v-if="isOpened"
			v-click-outside="{
				handler: 'closeTooltip',
				exclude: ['triple-dot']
			}"
			class="tooltip auto-width"
		>
			<div class="menu-more">
				<slot></slot>
			</div>
		</ja-tooltip>
	</div>
</template>

<script>
import '../../icons/more';

import Tooltip from '@/components/ui/Tooltip';
import Button from '@/components/ui/Button';

export default {
	components: {
		jaTooltip: Tooltip,
		jaButton: Button
	},
	props: {
		open: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isOpened: false
		};
	},
	watch: {
		open(value) {
			this.isOpened = value;
		}
	},
	methods: {
		closeTooltip() {
			this.isOpened = false;
			this.$emit('close');
		},
		toggleTooltip() {
			this.isOpened = !this.isOpened;
		}
	}
};
</script>
<style lang="scss" scoped>
.more-menu-btn {
	display: inline-block;
	max-width: 50px !important;
	min-width: 30px !important;
	height: auto;
	min-width: 0px;
	padding-left: 0px !important;
	padding-right: 0px !important;

	.small {
		padding-left: 0px;
		padding-right: 0px;
	}

	@media (any-hover: hover) {
		&:hover svg {
			fill: $hover-state;
			cursor: pointer;
		}
	}

	.svg-fill {
		height: 20px;
		width: 20px;
		fill: $primary-state !important;
		stroke: none !important;
	}

	.tooltip-msg {
		position: relative;
	}
}

::v-deep .tooltip {
	&.auto-width {
		width: initial;
	}
	right: -100px;
	position: absolute;
	margin-top: -47px;
	margin-right: 130px;

	.tooltip-pointer {
		z-index: -100;
	}

	.menu-more {
		min-width: 100px;
		align-items: flex-end;
		display: flex;
		flex-wrap: wrap;
		flex-direction: column;

		button.small {
			width: 100%;
			text-align: right;
			font-weight: bold;
			min-width: initial;
			padding-left: initial;
			padding-right: initial;
		}
	}
}
</style>
